import { HttpClient } from '@leanpay/http-client'

import { commonInterceptor } from '../interceptors'

class VendorMockService {
    _httpClient = new HttpClient({
        config: { baseURL: undefined, responseType: 'json' },
        interceptorConfig: {
            onRequestFulfilled: commonInterceptor,
        },
    })

    private _vendorTokenUrl = 'vendor/token'

    async getVendorMockToken(payload: any) {
        const { data } = await this._httpClient.post<any>(this._vendorTokenUrl, payload)
        return data
    }
}

export const vendorMockService = new VendorMockService()
